/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OnboardingStepSex = {
    sex?: OnboardingStepSex.sex;
};
export namespace OnboardingStepSex {
    export enum sex {
        UNKNOWN = 'unknown',
        MEN = 'men',
        WOMAN = 'woman',
    }
}

